module.exports = __webpack_public_path__ + "img/01.34db1589.png";